<template>
  <div class="help-content">
    <!-- 移动端进度指示器 -->
    <div class="mobile-progress-bar" v-if="isMobile">
      <div class="progress-fill" :style="{ width: scrollProgress + '%' }"></div>
    </div>

    <ul class="nav">
      <li
        class="nav-item"
        v-for="(item, index) in menuItems"
        :key="index"
        :class="{ active: currentActiveSection === item.anchor }"
      >
        <img class="icon-tb" src="@/assets/images/14tb.png" alt="" />
        <span
          @click.prevent="handleMenuClick(item)"
          @touchstart.prevent="handleTouchStart($event, item)"
          @touchend.prevent="handleTouchEnd($event, item)"
          @touchcancel.prevent="handleTouchCancel"
          :data-anchor="item.anchor"
          class="menu-clickable"
        >
          {{ item.title }}
        </span>
      </li>
    </ul>
    <div class="main">
      <router-view></router-view>
      <!-- <help-content v-show="isHelp"></help-content>
      <privacy-policy v-show="!isHelp"></privacy-policy> -->
    </div>
  </div>
</template>

<script>
/* eslint-disable vue/no-unused-components */
import HelpContent from "./HelpContent.vue";
import PrivacyPolicy from "./PrivacyPolicy.vue";
export default {
  name: "Help",
  components: {
    HelpContent, // eslint-disable-line vue/no-unused-components
    PrivacyPolicy, // eslint-disable-line vue/no-unused-components
  },
  props: {},
  data() {
    return {
      isHelp: true,
      currentActiveSection: "",
      scrollProgress: 0,
      isMobile: false,
      touchStartTime: 0,
      touchStartItem: null,
      touchMoved: false,
      menuItems: [
        {
          anchor: "help1",
          title: "如何下载安装电子书？",
          action: "scrollToAnchor",
        },
        {
          anchor: "help2",
          title: "如何激活电子书？",
          action: "scrollToAnchor",
        },
        {
          anchor: "help3",
          title: "如果选错书了怎么办？",
          action: "scrollToAnchor",
        },
        {
          anchor: "help4",
          title: "如何获得激活码？",
          action: "scrollToAnchor",
        },
        {
          anchor: "help5",
          title: "更多问题请关注微信。",
          action: "scrollToAnchor",
        },
        {
          anchor: "privacy",
          title: "隐私政策说明。",
          action: "openPrivacyPolicy",
        },
      ],
    };
  },
  computed: {},
  watch: {
    // 监听路由变化，更新激活状态
    $route() {
      this.updateActiveSection();
    },
  },
  mounted() {
    // 初始化激活状态
    this.updateActiveSection();
    // 检测设备类型
    this.checkDevice();
    window.addEventListener("resize", this.checkDevice);

    // 添加滚动监听
    window.addEventListener("scroll", this.handleScroll);

    // 延迟添加移动端事件监听，确保DOM完全渲染
    this.$nextTick(() => {
      setTimeout(() => {
        if (this.isMobile) {
          this.addMobileEventListeners();
        }
      }, 100);
    });
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.checkDevice);
    window.removeEventListener("scroll", this.handleScroll);

    if (this.isMobile) {
      this.removeMobileEventListeners();
    }
  },
  methods: {
    // 更新激活状态
    updateActiveSection() {
      const currentRouteName = this.$route.name;

      if (currentRouteName === "HelpPrivacy") {
        // 隐私政策页面
        this.currentActiveSection = "privacy";
      } else if (currentRouteName === "HelpQuestion") {
        // 帮助内容页面，根据锚点参数设置激活状态
        const anchor = this.$route.params.anchor;
        if (anchor) {
          this.currentActiveSection = anchor;
        } else {
          // 默认激活第一个菜单项
          this.currentActiveSection = "help1";
        }
      } else {
        // 其他情况，默认激活第一个菜单项
        this.currentActiveSection = "help1";
      }
    },

    // 检测设备类型（优化后的逻辑）
    checkDevice() {
      const width = window.innerWidth;
      const height = window.innerHeight;
      const userAgent = navigator.userAgent.toLowerCase();

      // 更精确的移动设备检测
      const isMobileUA =
        /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini|mobile/i.test(
          userAgent
        );
      const isTabletUA = /ipad|android(?=.*tablet)|tablet/i.test(userAgent);

      // 检测是否为触摸设备（但需要排除支持触摸的PC）
      const hasTouch = "ontouchstart" in window || navigator.maxTouchPoints > 0;

      // 屏幕比例检测（移动设备通常较窄）
      const aspectRatio = width / height;
      const isNarrowScreen = aspectRatio < 1.3; // 移动设备屏幕比例通常较窄

      // 综合判断移动设备
      this.isMobile =
        // 明确的移动设备UA
        isMobileUA ||
        // 小屏幕 + 触摸 + 窄屏比例（典型移动设备特征）
        (width <= 768 && hasTouch && isNarrowScreen) ||
        // 中等屏幕但具有明显移动特征
        (width <= 1024 && isMobileUA && hasTouch);

      // 平板设备特殊处理（可选择按移动端或PC端处理）
      const isTablet =
        isTabletUA || (width >= 768 && width <= 1024 && hasTouch);

      console.log("设备检测详情:", {
        width,
        height,
        aspectRatio: aspectRatio.toFixed(2),
        hasTouch,
        isMobileUA,
        isTabletUA,
        isTablet,
        isNarrowScreen,
        userAgent,
        finalResult: this.isMobile ? "移动端" : "PC端",
      });
    },

    // 移动端调试信息
    debugMobileEnvironment() {
      console.log("=== 移动端环境调试信息 ===");
      console.log("屏幕尺寸:", window.innerWidth, "x", window.innerHeight);
      console.log("设备像素比:", window.devicePixelRatio);
      console.log("用户代理:", navigator.userAgent);
      console.log("触摸支持:", "ontouchstart" in window);
      console.log("当前路由:", this.$route.name, this.$route.params);

      // 检查DOM元素
      const header = document.querySelector(".header-layout");
      const sections = document.querySelectorAll(".section");
      console.log(
        "头部元素:",
        header,
        header ? header.getBoundingClientRect() : null
      );
      console.log("Section元素数量:", sections.length);
      sections.forEach((section, index) => {
        console.log(
          `Section ${index}:`,
          section.className,
          section.getBoundingClientRect()
        );
      });

      // 检查滚动相关
      console.log(
        "当前滚动位置:",
        window.pageYOffset || document.documentElement.scrollTop
      );
      console.log("文档高度:", document.documentElement.scrollHeight);
      console.log("视口高度:", window.innerHeight);
    },

    // 处理滚动事件，更新进度和活跃状态
    handleScroll() {
      if (!this.isMobile) return;

      const scrollTop =
        window.pageYOffset || document.documentElement.scrollTop;
      const docHeight =
        document.documentElement.scrollHeight - window.innerHeight;
      this.scrollProgress = Math.min((scrollTop / docHeight) * 100, 100);

      // 检测当前可见的章节
      const sections = document.querySelectorAll(".section");
      let currentSection = "";

      sections.forEach((section) => {
        const rect = section.getBoundingClientRect();
        if (rect.top <= 150 && rect.bottom >= 150) {
          currentSection = section.classList[1] || ""; // 获取help1, help2等类名
        }
      });

      if (currentSection !== this.currentActiveSection) {
        this.currentActiveSection = currentSection;
        // 触觉反馈
        this.triggerHapticFeedback();
      }
    },

    // 触觉反馈
    triggerHapticFeedback() {
      if ("vibrate" in navigator && this.isMobile) {
        navigator.vibrate(50); // 轻微震动50ms
      }
    },

    handleMenuClick(item) {
      console.log(
        "PC端菜单点击事件:",
        item,
        "设备类型:",
        this.isMobile ? "移动端" : "PC端"
      );

      // 移动端调试
      if (this.isMobile) {
        console.log("移动端在PC点击事件中");
        this.debugMobileEnvironment();
      }

      this.executeMenuAction(item);
    },

    // 触摸开始事件
    handleTouchStart(event, item) {
      console.log("触摸开始:", item.anchor);
      this.touchStartTime = Date.now();
      this.touchStartItem = item;
      this.touchMoved = false;

      // 触觉反馈
      this.triggerHapticFeedback();

      // 添加视觉反馈
      const target = event.currentTarget;
      target.style.backgroundColor = "rgba(0, 153, 51, 0.1)";
      target.style.transform = "scale(0.98)";
    },

    // 触摸结束事件
    handleTouchEnd(event, item) {
      const touchDuration = Date.now() - this.touchStartTime;
      console.log(
        "触摸结束:",
        item.anchor,
        "持续时间:",
        touchDuration,
        "移动:",
        this.touchMoved
      );

      // 移除视觉反馈
      const target = event.currentTarget;
      target.style.backgroundColor = "";
      target.style.transform = "";

      // 检查是否为有效点击（短时间且没有移动）
      if (
        touchDuration < 500 &&
        !this.touchMoved &&
        this.touchStartItem === item
      ) {
        console.log("有效触摸点击:", item.anchor);
        this.executeMenuAction(item);
      } else {
        console.log("无效触摸:", {
          duration: touchDuration,
          moved: this.touchMoved,
          sameItem: this.touchStartItem === item,
        });
      }

      // 重置状态
      this.touchStartItem = null;
    },

    // 触摸取消事件
    handleTouchCancel() {
      console.log("触摸取消");
      this.touchStartItem = null;
      this.touchMoved = false;
    },

    // 统一的菜单行为执行
    executeMenuAction(item) {
      console.log(
        "执行菜单行为开始:",
        item,
        "设备类型:",
        this.isMobile ? "移动端" : "PC端"
      );

      try {
        if (!item) {
          console.error("菜单项为空:", item);
          return;
        }

        if (!item.action) {
          console.error("菜单项没有action属性:", item);
          return;
        }

        console.log("菜单行为类型:", item.action);

        if (item.action === "scrollToAnchor") {
          // 更新激活状态
          this.currentActiveSection = item.anchor;
          // 移动端和PC端使用统一的滚动逻辑
          this.scrollToAnchor(item.anchor);
        } else if (item.action === "openPrivacyPolicy") {
          // 立即更新激活状态
          this.currentActiveSection = item.anchor;
          this.openPrivacyPolicy();
        } else {
          console.error("未知的菜单行为:", item.action);
        }

        console.log("菜单行为执行完成");
      } catch (error) {
        console.error("菜单行为执行错误:", error);
        console.error("错误堆栈:", error.stack);

        // 错误后的备用方案：直接尝试简单滚动
        if (item && item.action === "scrollToAnchor") {
          console.log("尝试备用滚动方案");
          this.fallbackScroll(item.anchor);
        }
      }
    },

    // 备用滚动方案
    fallbackScroll(anchor) {
      console.log("执行备用滚动:", anchor);

      const element =
        document.querySelector(`.${anchor}`) ||
        document.querySelector(`#${anchor}`);
      if (element) {
        try {
          // 最简单直接的滚动方案
          element.scrollIntoView({
            behavior: "auto",
            block: "start",
          });

          // 延迟调整头部偏移
          setTimeout(() => {
            const currentScroll =
              window.pageYOffset || document.documentElement.scrollTop;
            const offset = this.isMobile ? 70 : 100;
            const targetPosition = Math.max(0, currentScroll - offset);

            document.documentElement.scrollTop = targetPosition;
            document.body.scrollTop = targetPosition;
            console.log("备用滚动调整完成:", targetPosition);
          }, 100);
        } catch (e) {
          console.log("备用滚动也失败:", e);
        }
      }
    },

    // 移动端专用锚点滚动处理
    handleMobileAnchorScroll(anchor) {
      console.log("移动端锚点滚动处理:", anchor);

      // 触觉反馈
      this.triggerHapticFeedback();

      // 紧急滚动模式：强制清除所有可能的阻止样式
      this.emergencyScrollFix();

      // 立即尝试查找元素
      const findAndScrollToElement = () => {
        console.log("开始查找目标元素:", anchor);

        const selectors = [
          `#${anchor}`,
          `.${anchor}`,
          `.section.${anchor}`,
          `[data-anchor="${anchor}"]`,
        ];

        let element = null;
        for (const selector of selectors) {
          element = document.querySelector(selector);
          if (element) {
            console.log("移动端找到目标元素:", selector, element);
            break;
          }
        }

        if (!element) {
          console.warn("移动端未找到锚点元素:", anchor);
          // 如果当前页面没有，可能需要路由跳转
          if (this.$route.name !== "HelpQuestion") {
            console.log("移动端需要路由跳转");
            this.$router
              .push({
                name: "HelpQuestion",
                params: { anchor: anchor },
                query: { ts: Date.now() },
              })
              .then(() => {
                setTimeout(() => {
                  this.handleMobileAnchorScroll(anchor);
                }, 500);
              });
            return;
          }
          return;
        }

        // 紧急滚动方案
        this.emergencyScroll(element, anchor);
      };

      findAndScrollToElement();
    },

    // 紧急滚动修复
    emergencyScrollFix() {
      console.log("执行紧急滚动修复");

      try {
        // 强制移除所有可能阻止滚动的样式
        const style = document.createElement("style");
        style.textContent = `
          html, body, #app, .basic-layout, .content-layout {
            overflow: auto !important;
            overflow-y: auto !important;
            overflow-x: hidden !important;
            height: auto !important;
            min-height: 100vh !important;
            position: static !important;
            transform: none !important;
            -webkit-overflow-scrolling: touch !important;
          }
          
          .el-main {
            overflow: auto !important;
            overflow-y: auto !important;
            height: auto !important;
            min-height: auto !important;
          }
          
          * {
            -webkit-transform: none !important;
            transform: none !important;
          }
          
          .nav-item a {
            display: inline !important;
            min-height: auto !important;
          }
        `;
        document.head.appendChild(style);

        // 强制重置关键容器
        const containers = [
          document.documentElement,
          document.body,
          document.querySelector("#app"),
          document.querySelector(".basic-layout"),
          document.querySelector(".content-layout"),
          document.querySelector(".el-main"),
        ];

        containers.forEach((container) => {
          if (container) {
            container.style.cssText += `
              overflow: auto !important;
              overflow-y: auto !important;
              height: auto !important;
              position: static !important;
              transform: none !important;
              -webkit-overflow-scrolling: touch !important;
            `;
          }
        });

        console.log("紧急滚动修复完成");

        // 延迟移除样式
        setTimeout(() => {
          if (style.parentNode) {
            style.parentNode.removeChild(style);
          }
        }, 10000);
      } catch (e) {
        console.log("紧急滚动修复失败:", e);
      }
    },

    // 紧急滚动方案
    emergencyScroll(element, anchor) {
      console.log("执行紧急滚动方案");

      const rect = element.getBoundingClientRect();
      const currentScroll =
        window.pageYOffset || document.documentElement.scrollTop;
      const offset = 70; // 固定偏移
      const targetPosition = Math.max(0, rect.top + currentScroll - offset);

      console.log("紧急滚动计算:", {
        elementTop: rect.top,
        currentScroll,
        targetPosition,
        elementRect: rect,
      });

      // 方法1: 最暴力的直接设置
      const bruteForcescroll = () => {
        console.log("执行暴力滚动");

        // 多次设置确保生效
        for (let i = 0; i < 5; i++) {
          setTimeout(() => {
            document.documentElement.scrollTop = targetPosition;
            document.body.scrollTop = targetPosition;
            window.scrollTo({
              top: targetPosition,
              left: 0,
              behavior: "auto",
            });

            // 验证滚动
            const checkScroll =
              window.pageYOffset || document.documentElement.scrollTop;
            console.log(`暴力滚动第${i + 1}次:`, checkScroll);
          }, i * 100);
        }
      };

      // 方法2: 使用requestAnimationFrame
      const rafScroll = () => {
        console.log("执行RAF滚动");

        const scroll = () => {
          document.documentElement.scrollTop = targetPosition;
          document.body.scrollTop = targetPosition;

          requestAnimationFrame(() => {
            const checkScroll =
              window.pageYOffset || document.documentElement.scrollTop;
            console.log("RAF滚动位置:", checkScroll);

            if (Math.abs(checkScroll - targetPosition) > 50) {
              requestAnimationFrame(scroll);
            }
          });
        };

        requestAnimationFrame(scroll);
      };

      // 方法3: 元素直接滚动到视图
      const elementScroll = () => {
        console.log("执行元素滚动");

        try {
          element.scrollIntoView({
            behavior: "auto",
            block: "start",
            inline: "nearest",
          });

          // 再次调整位置以考虑头部
          setTimeout(() => {
            const currentPos =
              window.pageYOffset || document.documentElement.scrollTop;
            const adjustedPos = Math.max(0, currentPos - offset);

            document.documentElement.scrollTop = adjustedPos;
            document.body.scrollTop = adjustedPos;
            console.log("元素滚动调整后位置:", adjustedPos);
          }, 100);
        } catch (e) {
          console.log("元素滚动失败:", e);
        }
      };

      // 执行所有方法
      bruteForcescroll();

      setTimeout(() => {
        rafScroll();
      }, 200);

      setTimeout(() => {
        elementScroll();
      }, 400);

      // 最终验证
      setTimeout(() => {
        const finalPosition =
          window.pageYOffset || document.documentElement.scrollTop;
        const success = Math.abs(finalPosition - targetPosition) < 100;

        console.log("紧急滚动最终结果:", {
          期望位置: targetPosition,
          实际位置: finalPosition,
          差异: Math.abs(finalPosition - targetPosition),
          成功: success,
        });

        if (!success) {
          console.log("所有紧急滚动方法都失败，尝试手动修改页面位置");
          // 最后的尝试：直接修改页面的transform
          document.body.style.transform = `translateY(-${targetPosition}px)`;

          setTimeout(() => {
            document.body.style.transform = "";
            document.documentElement.scrollTop = targetPosition;
          }, 500);
        }

        this.currentActiveSection = anchor;
      }, 1000);
    },

    // 确保移动端滚动可用
    ensureMobileScrollEnabled() {
      console.log("确保移动端滚动可用");

      try {
        // 移除可能阻止滚动的样式
        const elementsToFix = [
          document.documentElement,
          document.body,
          document.querySelector("#app"),
          document.querySelector(".basic-layout"),
          document.querySelector(".content-layout"),
        ];

        elementsToFix.forEach((element) => {
          if (element) {
            // 确保能够滚动
            element.style.overflow = "";
            element.style.overflowY = "";
            element.style.height = "";
            element.style.maxHeight = "";

            // 移除可能的固定定位
            if (element.style.position === "fixed") {
              element.style.position = "";
            }
          }
        });

        // 强制设置body和html可滚动
        document.documentElement.style.overflow = "auto";
        document.documentElement.style.overflowY = "auto";
        document.body.style.overflow = "auto";
        document.body.style.overflowY = "auto";

        console.log("移动端滚动样式已重置");
      } catch (e) {
        console.log("重置滚动样式失败:", e);
      }
    },

    // 移动端滚动执行
    executeMobileScroll(element, anchor) {
      console.log("执行移动端滚动:", element.className);

      // 移动端滚动环境检查
      this.checkMobileScrollEnvironment();

      const rect = element.getBoundingClientRect();
      const currentScroll =
        window.pageYOffset || document.documentElement.scrollTop;

      // 移动端头部偏移计算
      const calculateMobileOffset = () => {
        const width = window.innerWidth;
        let offset = 70; // 移动端默认

        if (width <= 480) offset = 60;
        else if (width <= 768) offset = 70;
        else if (width <= 1024) offset = 80;

        return offset;
      };

      const offset = calculateMobileOffset();
      const targetPosition = Math.max(0, rect.top + currentScroll - offset);

      console.log("移动端滚动计算:", {
        elementTop: rect.top,
        currentScroll,
        offset,
        targetPosition,
        windowHeight: window.innerHeight,
        documentHeight: document.documentElement.scrollHeight,
      });

      // 移动端专用滚动方法
      this.performMobileScrollToPosition(targetPosition, element);

      // 更新状态
      this.currentActiveSection = anchor;
    },

    // 移动端滚动环境检查
    checkMobileScrollEnvironment() {
      console.log("=== 移动端滚动环境检查 ===");
      console.log("viewport尺寸:", window.innerWidth, "x", window.innerHeight);
      console.log("文档高度:", document.documentElement.scrollHeight);
      console.log("当前滚动位置:", window.pageYOffset);
      console.log("body scrollTop:", document.body.scrollTop);
      console.log(
        "documentElement scrollTop:",
        document.documentElement.scrollTop
      );

      // 检查是否可以滚动
      const canScroll =
        document.documentElement.scrollHeight > window.innerHeight;
      console.log("页面是否可滚动:", canScroll);

      // 检查body和html的样式
      const htmlStyle = getComputedStyle(document.documentElement);
      const bodyStyle = getComputedStyle(document.body);
      console.log("html样式:", {
        overflow: htmlStyle.overflow,
        overflowY: htmlStyle.overflowY,
        height: htmlStyle.height,
      });
      console.log("body样式:", {
        overflow: bodyStyle.overflow,
        overflowY: bodyStyle.overflowY,
        height: bodyStyle.height,
      });
    },

    // 执行移动端滚动到指定位置
    performMobileScrollToPosition(targetPosition, element) {
      console.log("执行移动端滚动到位置:", targetPosition);

      // 方法1: 强制直接设置（移动端最可靠）
      const forceScrollMobile = () => {
        try {
          document.documentElement.scrollTop = targetPosition;
          document.body.scrollTop = targetPosition;
          window.scrollTo(0, targetPosition);
          console.log("移动端强制滚动方法执行");
          return true;
        } catch (e) {
          console.log("移动端强制滚动失败:", e);
          return false;
        }
      };

      // 方法2: 使用scrollIntoView
      const scrollIntoViewMobile = () => {
        try {
          element.scrollIntoView({
            block: "start",
            inline: "nearest",
          });
          console.log("移动端scrollIntoView执行");
          return true;
        } catch (e) {
          console.log("移动端scrollIntoView失败:", e);
          return false;
        }
      };

      // 方法3: 分步滚动（移动端有时需要）
      const stepScrollMobile = () => {
        try {
          const steps = 5;
          const stepSize = targetPosition / steps;
          let currentStep = 0;

          const scrollStep = () => {
            currentStep++;
            const stepPosition = stepSize * currentStep;
            document.documentElement.scrollTop = stepPosition;
            document.body.scrollTop = stepPosition;

            if (currentStep < steps) {
              setTimeout(scrollStep, 50);
            } else {
              console.log("移动端分步滚动完成");
            }
          };

          scrollStep();
          return true;
        } catch (e) {
          console.log("移动端分步滚动失败:", e);
          return false;
        }
      };

      // 执行滚动
      let success = forceScrollMobile();

      if (!success) {
        success = scrollIntoViewMobile();
      }

      // 延迟验证和重试
      setTimeout(() => {
        const currentScroll =
          window.pageYOffset || document.documentElement.scrollTop;
        const difference = Math.abs(currentScroll - targetPosition);

        console.log("移动端滚动验证:", {
          期望位置: targetPosition,
          实际位置: currentScroll,
          差异: difference,
          是否成功: difference < 100,
        });

        // 如果滚动不成功，尝试分步滚动
        if (difference > 100) {
          console.log("移动端滚动未成功，尝试分步滚动");
          stepScrollMobile();

          // 最终验证
          setTimeout(() => {
            const finalScroll =
              window.pageYOffset || document.documentElement.scrollTop;
            console.log("移动端最终滚动位置:", finalScroll);
          }, 500);
        }
      }, 300);
    },

    // 滚动到锚点（统一方法）
    scrollToAnchor(anchor) {
      console.log(
        "统一锚点滚动开始:",
        anchor,
        "设备类型:",
        this.isMobile ? "移动端" : "PC端"
      );

      try {
        if (!anchor) {
          console.error("锚点为空:", anchor);
          return;
        }

        console.log("触发触觉反馈...");
        this.triggerHapticFeedback();

        const performDirectScroll = () => {
          console.log("开始统一滚动处理");
          setTimeout(() => {
            console.log("执行延迟滚动...");
            this.unifiedScroll(anchor);
          }, 100);
        };

        console.log("检查当前路由:", this.$route.name);
        if (this.$route.name === "HelpQuestion") {
          console.log("当前在帮助页面，直接滚动");
          performDirectScroll();
          return;
        }

        console.log("需要路由跳转到帮助页面");
        this.$router
          .push({
            name: "HelpQuestion",
            params: { anchor: anchor },
            query: { ts: Date.now() },
          })
          .then(() => {
            console.log("路由跳转完成");
            setTimeout(() => {
              console.log("路由跳转后执行滚动...");
              this.unifiedScroll(anchor);
            }, 300);
          })
          .catch((err) => {
            console.log("路由跳转失败:", err);
            performDirectScroll();
          });
      } catch (error) {
        console.error("scrollToAnchor执行错误:", error);
        console.error("错误堆栈:", error.stack);
      }
    },

    // 统一滚动处理方法
    unifiedScroll(anchor) {
      console.log("执行统一滚动:", anchor);

      // 查找目标元素
      const selectors = [
        `#${anchor}`,
        `.${anchor}`,
        `.section.${anchor}`,
        `[data-anchor="${anchor}"]`,
      ];

      let element = null;
      for (const selector of selectors) {
        element = document.querySelector(selector);
        if (element) {
          console.log("找到目标元素:", selector);
          break;
        }
      }

      if (!element) {
        console.warn("未找到锚点元素:", anchor);
        return;
      }

      // 计算滚动位置
      const rect = element.getBoundingClientRect();
      const currentScroll =
        window.pageYOffset || document.documentElement.scrollTop;

      // 动态计算偏移量
      const calculateOffset = () => {
        const width = window.innerWidth;
        let offset = 100; // 默认偏移

        if (width <= 480) offset = 70;
        else if (width <= 768) offset = 80;
        else if (width <= 1024) offset = 90;

        return offset;
      };

      const offset = calculateOffset();
      const targetPosition = Math.max(0, rect.top + currentScroll - offset);

      console.log("统一滚动计算:", {
        elementTop: rect.top,
        currentScroll,
        offset,
        targetPosition,
        deviceType: this.isMobile ? "移动端" : "PC端",
      });

      // 执行滚动
      this.executeUnifiedScroll(targetPosition, element);

      // 更新状态
      this.currentActiveSection = anchor;
    },

    // 执行统一滚动
    executeUnifiedScroll(targetPosition, element) {
      console.log("执行统一滚动到位置:", targetPosition);

      // 方法1: 直接设置（最可靠的方法）
      const directScroll = () => {
        document.documentElement.scrollTop = targetPosition;
        document.body.scrollTop = targetPosition;
        console.log("直接滚动执行");
        return true;
      };

      // 方法2: window.scrollTo
      const windowScroll = () => {
        window.scrollTo(0, targetPosition);
        console.log("window.scrollTo执行");
        return true;
      };

      // 方法3: scrollIntoView + 调整
      const elementScroll = () => {
        element.scrollIntoView({
          behavior: "auto",
          block: "start",
        });

        setTimeout(() => {
          const currentPos =
            window.pageYOffset || document.documentElement.scrollTop;
          const offset =
            targetPosition - (element.getBoundingClientRect().top + currentPos);
          if (Math.abs(offset) > 20) {
            document.documentElement.scrollTop = targetPosition;
            document.body.scrollTop = targetPosition;
          }
          console.log("元素滚动调整完成");
        }, 50);

        return true;
      };

      // 按序执行滚动方法
      let success = false;

      try {
        success = directScroll();
      } catch (e) {
        console.log("直接滚动失败:", e);
      }

      if (!success) {
        try {
          success = windowScroll();
        } catch (e) {
          console.log("window滚动失败:", e);
        }
      }

      if (!success) {
        try {
          success = elementScroll();
        } catch (e) {
          console.log("元素滚动失败:", e);
        }
      }

      // 验证滚动结果
      setTimeout(() => {
        const finalPosition =
          window.pageYOffset || document.documentElement.scrollTop;
        const difference = Math.abs(finalPosition - targetPosition);

        console.log("统一滚动验证:", {
          期望位置: targetPosition,
          实际位置: finalPosition,
          差异: difference,
          成功: difference < 100,
          设备类型: this.isMobile ? "移动端" : "PC端",
        });

        // 如果滚动不准确，再次调整
        if (difference > 50) {
          console.log("滚动位置不准确，再次调整");
          document.documentElement.scrollTop = targetPosition;
          document.body.scrollTop = targetPosition;
        }
      }, 300);
    },

    // 滚动到指定元素
    scrollToElement(element, anchor) {
      console.log("滚动到元素:", element.className);

      // 添加滚动环境检查
      this.checkScrollEnvironment();

      // 计算头部偏移量
      const calculateOffset = () => {
        const width = window.innerWidth;
        let baseHeight = 88; // PC端默认

        // 响应式调整
        if (width <= 480) {
          baseHeight = 50;
        } else if (width <= 768) {
          baseHeight = 60;
        } else if (width <= 1024) {
          baseHeight = 70;
        }

        // 检查实际头部高度
        const header = document.querySelector(".header-layout");
        if (header) {
          const headerRect = header.getBoundingClientRect();
          if (headerRect.height > 0) {
            baseHeight = headerRect.height;
          }
        }

        // 添加安全边距
        const extraPadding = width <= 768 ? 30 : 20;
        return baseHeight + extraPadding;
      };

      const rect = element.getBoundingClientRect();
      const scrollTop =
        window.pageYOffset || document.documentElement.scrollTop;
      const offset = calculateOffset();
      const targetPosition = rect.top + scrollTop - offset;
      const finalPosition = Math.max(0, targetPosition);

      console.log("滚动计算:", {
        elementTop: rect.top,
        currentScroll: scrollTop,
        offset: offset,
        targetPosition: targetPosition,
        finalPosition: finalPosition,
        deviceWidth: window.innerWidth,
      });

      // 执行滚动
      this.executeScroll(finalPosition, element);

      // 更新状态
      this.currentActiveSection = anchor;
    },

    // 检查滚动环境
    checkScrollEnvironment() {
      console.log("=== 滚动环境检查 ===");
      console.log(
        "document.documentElement.scrollTop:",
        document.documentElement.scrollTop
      );
      console.log("document.body.scrollTop:", document.body.scrollTop);
      console.log("window.pageYOffset:", window.pageYOffset);
      console.log(
        "document.documentElement.scrollHeight:",
        document.documentElement.scrollHeight
      );
      console.log("window.innerHeight:", window.innerHeight);

      // 检查可能的滚动容器
      const containers = [
        "html",
        "body",
        "#app",
        ".basic-layout",
        ".content-layout",
        ".help-content",
      ];

      containers.forEach((selector) => {
        const element = document.querySelector(selector);
        if (element) {
          console.log(`${selector}:`, {
            scrollTop: element.scrollTop,
            scrollHeight: element.scrollHeight,
            clientHeight: element.clientHeight,
            overflow: getComputedStyle(element).overflow,
            overflowY: getComputedStyle(element).overflowY,
          });
        }
      });
    },

    // 执行滚动操作
    executeScroll(targetPosition, element) {
      console.log("执行滚动到位置:", targetPosition);

      // 强制禁用smooth滚动，直接跳转
      const forceScroll = (position) => {
        // 方法1: 直接设置scrollTop（最可靠）
        try {
          document.documentElement.scrollTop = position;
          document.body.scrollTop = position;
          console.log("强制滚动方法1执行");
          return true;
        } catch (e) {
          console.log("强制滚动方法1失败:", e);
          return false;
        }
      };

      // 方法2: window.scrollTo（无smooth）
      const windowScroll = (position) => {
        try {
          window.scrollTo(0, position);
          console.log("window.scrollTo执行");
          return true;
        } catch (e) {
          console.log("window.scrollTo失败:", e);
          return false;
        }
      };

      // 方法3: 尝试scrollIntoView
      const elementScroll = () => {
        try {
          const elementRect = element.getBoundingClientRect();

          // 如果元素已经在视口中，不需要滚动
          if (
            elementRect.top >= 0 &&
            elementRect.top <= window.innerHeight / 2
          ) {
            console.log("元素已在合适位置，无需滚动");
            return true;
          }

          element.scrollIntoView({
            block: "start",
            inline: "nearest",
          });
          console.log("scrollIntoView执行");
          return true;
        } catch (e) {
          console.log("scrollIntoView失败:", e);
          return false;
        }
      };

      // 立即执行强制滚动
      let success = false;

      // 首先尝试直接设置
      success = forceScroll(targetPosition);

      if (!success) {
        success = windowScroll(targetPosition);
      }

      if (!success) {
        success = elementScroll();
      }

      // 延迟再次确认滚动位置
      setTimeout(() => {
        const currentScroll =
          window.pageYOffset || document.documentElement.scrollTop;
        const difference = Math.abs(currentScroll - targetPosition);

        console.log("滚动验证:", {
          期望位置: targetPosition,
          实际位置: currentScroll,
          差异: difference,
          是否成功: difference < 100,
        });

        // 如果还是没有滚动到正确位置，再次尝试
        if (difference > 100) {
          console.log("滚动未成功，再次尝试强制滚动");
          forceScroll(targetPosition);

          // 最终验证
          setTimeout(() => {
            const finalScroll =
              window.pageYOffset || document.documentElement.scrollTop;
            console.log("最终滚动位置:", finalScroll);
          }, 200);
        }
      }, 500);

      if (!success) {
        console.error("所有滚动方法都失败了");
      }
    },

    toTop() {
      console.log("To Top 点击");

      // 直接滚动到页面绝对顶部
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth",
      });

      // 多重保障确保滚动到顶部
      setTimeout(() => {
        // 强制设置滚动位置为0
        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0;

        // 处理可能的父级滚动容器
        const containers = [
          document.querySelector(".help-content"),
          document.querySelector(".main"),
          document.querySelector(".content-layout"),
          document.querySelector(".basic-layout"),
        ];

        containers.forEach((container) => {
          if (container && container.scrollTop > 0) {
            container.scrollTop = 0;
          }
        });

        console.log(
          "To Top 执行完成，当前滚动位置:",
          window.pageYOffset || document.documentElement.scrollTop
        );
      }, 300);

      // 额外的安全检查，确保真正到达顶部
      setTimeout(() => {
        const currentScroll =
          window.pageYOffset || document.documentElement.scrollTop;
        if (currentScroll > 0) {
          console.log(
            "检测到未完全置顶，再次执行滚动，当前位置:",
            currentScroll
          );
          document.documentElement.scrollTop = 0;
          document.body.scrollTop = 0;
          window.scrollTo(0, 0);
        }
      }, 1000);
    },

    openPrivacyPolicy() {
      this.$router.push({
        name: "HelpPrivacy",
        query: { ts: Date.now() },
      });
    },

    // 添加移动端事件监听
    addMobileEventListeners() {
      console.log("添加移动端事件监听，设备类型:", this.isMobile);

      // 等待DOM稳定后再添加事件
      setTimeout(() => {
        const nav = document.querySelector(".nav");
        const menuItems = document.querySelectorAll(".menu-clickable");

        console.log("DOM检查:", {
          nav: !!nav,
          menuItems: menuItems.length,
          isMobile: this.isMobile,
        });

        if (nav) {
          nav.addEventListener("touchstart", this.handleNavTouchStart, {
            passive: false,
          });
          nav.addEventListener("touchend", this.handleNavTouchEnd, {
            passive: false,
          });
          nav.addEventListener("click", this.handleNavClick, {
            passive: false,
          });
          console.log("移动端事件监听已添加到导航区域");
        } else {
          console.warn("未找到导航区域，无法添加事件监听");
        }

        // 为每个菜单项添加额外的点击监听（备用方案）
        menuItems.forEach((item, index) => {
          item.addEventListener("click", (e) => {
            console.log(`菜单项${index}被点击:`, item.dataset.anchor);
            e.preventDefault();
            const anchor = item.dataset.anchor;
            const menuItem = this.menuItems.find((mi) => mi.anchor === anchor);
            if (menuItem) {
              this.executeMenuAction(menuItem);
            }
          });
        });
      }, 200);
    },

    // 移除移动端事件监听
    removeMobileEventListeners() {
      const nav = document.querySelector(".nav");
      if (nav) {
        nav.removeEventListener("touchstart", this.handleNavTouchStart);
        nav.removeEventListener("touchend", this.handleNavTouchEnd);
        nav.removeEventListener("click", this.handleNavClick);
      }
    },

    // 导航区域触摸开始
    handleNavTouchStart(event) {
      const target = event.target.closest(".menu-clickable");
      if (target) {
        const anchor = target.dataset.anchor;
        const item = this.menuItems.find((item) => item.anchor === anchor);
        if (item) {
          console.log("导航触摸开始:", anchor);
          this.handleTouchStart(event, item);
        }
      }
    },

    // 导航区域触摸结束
    handleNavTouchEnd(event) {
      const target = event.target.closest(".menu-clickable");
      if (target) {
        const anchor = target.dataset.anchor;
        const item = this.menuItems.find((item) => item.anchor === anchor);
        if (item) {
          console.log("导航触摸结束:", anchor);
          this.handleTouchEnd(event, item);
        }
      }
    },

    // 导航区域点击（备用）
    handleNavClick(event) {
      console.log("导航区域点击事件触发");
      event.preventDefault();

      try {
        // 尝试多种方式查找目标元素
        let target = event.target.closest(".menu-clickable");
        console.log("查找目标元素方式1:", target);

        // 如果第一种方式失败，尝试其他方式
        if (!target) {
          target = event.target.closest("span[data-anchor]");
          console.log("查找目标元素方式2:", target);
        }

        if (!target) {
          target = event.target.closest(".nav-item span");
          console.log("查找目标元素方式3:", target);
        }

        if (!target) {
          // 最后尝试：检查点击的元素本身是否就是目标
          if (event.target.dataset && event.target.dataset.anchor) {
            target = event.target;
            console.log("查找目标元素方式4 (直接元素):", target);
          }
        }

        if (!target) {
          // 终极方案：查找父级nav-item下的span
          const navItem = event.target.closest(".nav-item");
          if (navItem) {
            target = navItem.querySelector("span[data-anchor]");
            console.log("查找目标元素方式5 (nav-item内查找):", target);
          }
        }

        console.log("最终找到的目标元素:", target);

        if (target) {
          const anchor = target.dataset.anchor;
          console.log("获取锚点:", anchor);

          if (anchor) {
            const item = this.menuItems.find((item) => item.anchor === anchor);
            console.log("查找菜单项:", item);

            if (item) {
              console.log("导航点击:", anchor);
              console.log("准备执行菜单行为...");
              this.executeMenuAction(item);
            } else {
              console.error("未找到对应的菜单项:", anchor);
              // 尝试直接滚动
              this.fallbackScroll(anchor);
            }
          } else {
            console.error("目标元素没有data-anchor属性:", target);
          }
        } else {
          console.error("未找到可点击的目标元素");
          console.log("点击的元素:", event.target);
          console.log("事件详情:", {
            target: event.target,
            tagName: event.target.tagName,
            className: event.target.className,
            dataset: event.target.dataset,
          });

          // 紧急备用方案：尝试解析元素内容
          const clickedText = event.target.textContent.trim();
          console.log("点击的文本内容:", clickedText);

          const matchedItem = this.menuItems.find(
            (item) =>
              item.title.includes(clickedText) ||
              clickedText.includes(item.title)
          );

          if (matchedItem) {
            console.log("通过文本匹配找到菜单项:", matchedItem);
            this.executeMenuAction(matchedItem);
          }
        }
      } catch (error) {
        console.error("导航点击事件处理错误:", error);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
// 移动端进度条
.mobile-progress-bar {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  background: rgba(255, 255, 255, 0.3);
  z-index: 9999;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);

  .progress-fill {
    height: 100%;
    background: linear-gradient(90deg, #059669 0%, #10b981 50%, #34d399 100%);
    transition: width 0.3s ease;
    border-radius: 0 2px 2px 0;
    box-shadow: 0 0 10px rgba(5, 150, 105, 0.5);
  }
}

.help-content {
  width: 1002px;
  margin: 0 auto;
  display: flex;

  .nav {
    width: 212px;
    background: rgba(255, 255, 255, 0.6);
    box-shadow: 0 0 12px 0px rgba(0, 0, 0, 0.5);
    padding: 26px 0;
    position: relative;
    z-index: 9;

    &-item {
      padding: 10px 0 10px 20px;
      height: 36px;
      overflow: hidden;
      position: relative;

      // PC端活跃状态
      &.active {
        background: rgba(0, 153, 51, 0.1);
        border-left: 3px solid #059669;

        span {
          color: #059669;
          font-weight: 600;
        }
      }

      .icon-tb {
        width: 17px;
        height: 16px;
        float: left;
      }

      span {
        float: left;
        font-size: 12px;
        color: #000;
        line-height: 16px;
        margin-left: 20px;
        cursor: pointer;
        transition: all 0.3s ease;

        &:hover {
          color: #093;
          text-decoration: underline;
        }
      }
    }
  }

  .main {
    flex: 1;
    background: white;
    padding: 16px 60px 0 30px;
    ::v-deep .section {
      padding: 20px;
      h3 {
        font-size: 24px;
        color: #090;
        line-height: 1.5em;
        .toTop {
          font-size: 12px;
          color: #000;
          cursor: pointer;
          &:hover {
            text-decoration: underline;
          }
        }
      }
      h4 {
        font-size: 18px;
        color: #000;
        margin: 20px 0;
        line-height: 1.5em;
      }
      .paragraph1 {
        font-size: 16px;
        color: #666;
        line-height: 2em;
      }
      .img-wrap {
        img {
          margin: 0 auto;
        }
      }
    }
  }
}

// 移动端响应式样式
@media (max-width: 1024px) {
  .help-content {
    width: 100% !important;
    max-width: 600px !important; // 限制最大宽度
    margin: 0 auto !important; // 整体居中
    flex-direction: column !important;
    padding: 20px 15px 0 15px !important; // 减少顶部间距

    .nav {
      width: 100% !important;
      max-width: 500px !important; // 限制导航最大宽度
      margin: 12px auto 24px auto !important; // 减少顶部间距
      background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%) !important;
      padding: 20px 0 !important;
      border-radius: 16px !important;
      box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12), 0 2px 8px rgba(0, 0, 0, 0.08) !important;
      border: 1px solid rgba(255, 255, 255, 0.8) !important;
      backdrop-filter: blur(20px) !important;
      -webkit-backdrop-filter: blur(20px) !important;

      &-item {
        padding: 16px 24px !important;
        height: auto !important;
        min-height: 56px !important; // 增加触摸目标尺寸
        display: flex !important;
        align-items: center !important;
        justify-content: flex-start !important; // 确保内容对齐
        border-bottom: 1px solid rgba(0, 0, 0, 0.06) !important;
        margin: 0 16px !important;
        border-radius: 12px !important;
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
        position: relative !important;
        overflow: hidden !important;

        // 移动端活跃状态
        &.active {
          background: linear-gradient(
            135deg,
            #ecfdf5 0%,
            #d1fae5 100%
          ) !important;
          border: 2px solid rgba(5, 150, 105, 0.3) !important;
          box-shadow: 0 4px 20px rgba(5, 150, 105, 0.15) !important;
          transform: translateY(-2px) !important;

          .icon-tb {
            filter: brightness(0.3) saturate(1.5) hue-rotate(120deg) !important;
            transform: scale(1.1) !important;
          }

          span {
            color: #047857 !important;
            font-weight: 700 !important;
          }

          &::after {
            color: #047857 !important;
            transform: translateX(4px) scale(1.1) !important;
            content: "◉" !important; // 使用实心圆点表示活跃状态
          }

          .active-indicator {
            background: #047857 !important;
            animation: pulse-active 1.5s infinite !important;
            box-shadow: 0 0 0 0 rgba(4, 120, 87, 0.8) !important;
          }
        }

        // 添加微妙的渐变背景
        &::before {
          content: "" !important;
          position: absolute !important;
          top: 0 !important;
          left: 0 !important;
          right: 0 !important;
          bottom: 0 !important;
          background: linear-gradient(
            90deg,
            transparent 0%,
            rgba(0, 153, 51, 0.03) 50%,
            transparent 100%
          ) !important;
          opacity: 0 !important;
          transition: opacity 0.3s ease !important;
        }

        &:last-child {
          border-bottom: none !important;
        }

        &:hover::before,
        &:focus::before {
          opacity: 1 !important;
        }

        // 增强的触摸反馈
        &:active:not(.active) {
          transform: scale(0.98) translateY(1px) !important;
          box-shadow: 0 2px 8px rgba(0, 153, 51, 0.15) !important;
          background: linear-gradient(
            135deg,
            #f0f9ff 0%,
            #e0f2fe 100%
          ) !important;
          border-color: rgba(0, 153, 51, 0.2) !important;
        }

        // 长按效果
        &:focus {
          outline: none !important;
          box-shadow: 0 0 0 3px rgba(0, 153, 51, 0.2) !important;
          background: rgba(0, 153, 51, 0.05) !important;
        }

        .icon-tb {
          width: 24px !important;
          height: 22px !important;
          float: none !important;
          margin-right: 16px !important;
          filter: brightness(0.7) !important;
          transition: all 0.3s ease !important;
        }

        span {
          float: none !important;
          font-size: 16px !important;
          font-weight: 500 !important;
          line-height: 1.5 !important;
          margin-left: 0 !important;
          flex: 1 !important;
          cursor: pointer !important;
          color: #374151 !important;
          transition: all 0.3s ease !important;

          &:hover,
          &:focus {
            color: #059669 !important;
            text-decoration: none !important;
          }

          // 移动端触摸优化
          &.menu-clickable {
            -webkit-tap-highlight-color: transparent !important;
            -webkit-touch-callout: none !important;
            -webkit-user-select: none !important;
            user-select: none !important;
            touch-action: manipulation !important;

            // 确保足够的触摸目标
            min-height: 44px !important;
            display: flex !important;
            align-items: center !important;

            // 触摸状态
            &:active {
              background-color: rgba(0, 153, 51, 0.1) !important;
              transform: scale(0.98) !important;
            }
          }
        }

        // 添加右侧指示箭头
        &::after {
          content: "›" !important;
          font-size: 20px !important;
          color: #9ca3af !important;
          margin-left: 12px !important;
          transition: all 0.3s ease !important;
          opacity: 0.6 !important;
        }

        &:hover::after,
        &:focus::after {
          color: #059669 !important;
          transform: translateX(4px) !important;
          opacity: 1 !important;
        }

        &:active:not(.active) {
          .icon-tb {
            filter: brightness(0.4) saturate(1.2) !important;
            transform: scale(1.1) !important;
          }

          span {
            color: #047857 !important;
          }

          &::after {
            color: #047857 !important;
            transform: translateX(2px) scale(0.9) !important;
          }
        }
      }
    }

    .main {
      flex: none !important;
      width: 100% !important;
      padding: 0 !important;
      background: white !important;
      border-radius: 16px !important;
      box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12), 0 2px 8px rgba(0, 0, 0, 0.08) !important;
      overflow: hidden !important;

      ::v-deep .section {
        padding: 24px !important;

        h3 {
          font-size: 28px !important;
          text-align: center !important;
          margin-bottom: 24px !important;
          color: #059669 !important;
          font-weight: 600 !important;

          .toTop {
            font-size: 14px !important;
            margin-left: 16px !important;
            background: linear-gradient(
              135deg,
              #f3f4f6 0%,
              #e5e7eb 100%
            ) !important;
            color: #374151 !important;
            padding: 8px 16px !important;
            border-radius: 20px !important;
            text-decoration: none !important;
            transition: all 0.3s ease !important;
            border: 1px solid #d1d5db !important;
            display: inline-flex !important;
            align-items: center !important;
            min-height: 36px !important;
            font-weight: 500 !important;

            &:hover,
            &:focus {
              background: linear-gradient(
                135deg,
                #059669 0%,
                #047857 100%
              ) !important;
              color: white !important;
              transform: translateY(-2px) !important;
              box-shadow: 0 4px 12px rgba(5, 150, 105, 0.3) !important;
              border-color: #059669 !important;
            }

            &:active {
              transform: translateY(0px) scale(0.95) !important;
              box-shadow: 0 2px 6px rgba(5, 150, 105, 0.4) !important;
            }
          }
        }

        h4 {
          font-size: 20px !important;
          margin: 28px 0 16px 0 !important;
          color: #111827 !important;
          font-weight: 600 !important;
        }

        .paragraph1 {
          font-size: 16px !important;
          line-height: 1.7 !important;
          margin-bottom: 20px !important;
          color: #4b5563 !important;
        }

        .img-wrap {
          text-align: center !important;
          margin: 28px 0 !important;

          img {
            max-width: 100% !important;
            height: auto !important;
            border-radius: 12px !important;
            box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1) !important;
          }
        }
      }
    }
  }
}

// 小屏幕设备优化
@media (max-width: 768px) {
  .help-content {
    padding: 0 12px !important;

    .nav {
      padding: 16px 0 !important;
      margin-bottom: 20px !important;
      border-radius: 14px !important;

      &-item {
        padding: 14px 20px !important;
        min-height: 52px !important;
        margin: 0 12px !important;
        border-radius: 10px !important;

        .icon-tb {
          width: 22px !important;
          height: 20px !important;
          margin-right: 14px !important;
        }

        span {
          font-size: 15px !important;
          font-weight: 500 !important;
        }

        &::after {
          font-size: 18px !important;
          margin-left: 10px !important;
        }
      }
    }

    .main {
      border-radius: 14px !important;

      ::v-deep .section {
        padding: 20px !important;

        h3 {
          font-size: 24px !important;
          margin-bottom: 20px !important;

          .toTop {
            font-size: 13px !important;
            margin-left: 12px !important;
            padding: 6px 14px !important;
            border-radius: 18px !important;
            min-height: 32px !important;
          }
        }

        h4 {
          font-size: 18px !important;
          margin: 24px 0 14px 0 !important;
        }

        .paragraph1 {
          font-size: 15px !important;
          line-height: 1.6 !important;
          margin-bottom: 18px !important;
        }

        .img-wrap {
          margin: 24px 0 !important;

          img {
            border-radius: 10px !important;
          }
        }
      }
    }
  }
}

// 超小屏幕优化
@media (max-width: 480px) {
  .help-content {
    padding: 0 10px !important;

    .nav {
      padding: 14px 0 !important;
      margin-bottom: 16px !important;
      border-radius: 12px !important;

      &-item {
        padding: 12px 16px !important;
        min-height: 48px !important;
        margin: 0 10px !important;
        border-radius: 8px !important;

        .icon-tb {
          width: 20px !important;
          height: 18px !important;
          margin-right: 12px !important;
        }

        span {
          font-size: 14px !important;
          line-height: 1.4 !important;
        }

        &::after {
          font-size: 16px !important;
          margin-left: 8px !important;
        }
      }
    }

    .main {
      border-radius: 12px !important;

      ::v-deep .section {
        padding: 16px !important;

        h3 {
          font-size: 22px !important;
          margin-bottom: 18px !important;

          .toTop {
            font-size: 12px !important;
            margin-left: 10px !important;
            padding: 5px 12px !important;
            border-radius: 16px !important;
            min-height: 28px !important;
          }
        }

        h4 {
          font-size: 16px !important;
          margin: 20px 0 12px 0 !important;
        }

        .paragraph1 {
          font-size: 14px !important;
          line-height: 1.5 !important;
          margin-bottom: 16px !important;
        }

        .img-wrap {
          margin: 20px 0 !important;

          img {
            border-radius: 8px !important;
          }
        }
      }
    }
  }
}

// 增强的触摸设备优化
@media (hover: none) and (pointer: coarse) {
  .help-content {
    .nav {
      &-item {
        -webkit-tap-highlight-color: transparent !important;
        cursor: pointer !important;

        // 增强触摸反馈
        &:active {
          transform: scale(0.96) translateY(2px) !important;
          background: linear-gradient(
            135deg,
            #ecfdf5 0%,
            #d1fae5 100%
          ) !important;
          border-color: rgba(0, 153, 51, 0.3) !important;
          box-shadow: 0 4px 12px rgba(0, 153, 51, 0.2) !important;

          .icon-tb {
            filter: brightness(0.3) saturate(1.5) hue-rotate(120deg) !important;
            transform: scale(1.15) !important;
          }

          span {
            color: #047857 !important;
            font-weight: 600 !important;
          }

          &::after {
            color: #047857 !important;
            transform: translateX(3px) scale(1.1) !important;
          }
        }

        // 长按效果优化
        &:focus {
          outline: none !important;
          box-shadow: 0 0 0 4px rgba(0, 153, 51, 0.15) !important;
          background: rgba(0, 153, 51, 0.08) !important;
        }

        // 添加涟漪效果
        &::before {
          background: radial-gradient(
            circle at center,
            rgba(0, 153, 51, 0.2) 0%,
            transparent 70%
          ) !important;
        }

        &:active::before {
          opacity: 1 !important;
          animation: ripple 0.6s ease-out !important;
        }
      }
    }

    .main {
      ::v-deep .section {
        h3 {
          .toTop {
            -webkit-tap-highlight-color: transparent !important;
            cursor: pointer !important;

            &:active {
              transform: translateY(1px) scale(0.92) !important;
              box-shadow: 0 3px 8px rgba(5, 150, 105, 0.5) !important;
              background: linear-gradient(
                135deg,
                #047857 0%,
                #065f46 100%
              ) !important;
            }

            // 长按效果
            &:focus {
              outline: none !important;
              box-shadow: 0 0 0 3px rgba(5, 150, 105, 0.3) !important;
            }
          }
        }
      }
    }
  }
}

// 添加涟漪动画
@keyframes ripple {
  0% {
    transform: scale(0);
    opacity: 1;
  }
  100% {
    transform: scale(4);
    opacity: 0;
  }
}

// 活跃状态专用脉冲动画
@keyframes pulse-active {
  0% {
    box-shadow: 0 0 0 0 rgba(4, 120, 87, 0.8);
    transform: scale(1);
  }
  50% {
    box-shadow: 0 0 0 8px rgba(4, 120, 87, 0.1);
    transform: scale(1.1);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(4, 120, 87, 0);
    transform: scale(1);
  }
}

// 高对比度模式支持
@media (prefers-contrast: high) {
  .help-content {
    .nav {
      background: #ffffff !important;
      border: 2px solid #000000 !important;

      &-item {
        border: 1px solid #666666 !important;

        span {
          color: #000000 !important;
        }

        &:hover,
        &:focus {
          background: #000000 !important;

          span {
            color: #ffffff !important;
          }
        }
      }
    }
  }
}

// 减少动画偏好设置支持
@media (prefers-reduced-motion: reduce) {
  .help-content {
    .nav {
      &-item,
      &-item::before,
      &-item::after,
      .icon-tb,
      span {
        transition: none !important;
        animation: none !important;
      }
    }

    .main {
      ::v-deep .section {
        h3 {
          .toTop {
            transition: none !important;
          }
        }
      }
    }
  }
}

// 针对小屏幕设备的额外优化
@media (max-width: 480px) {
  .help-content {
    padding: 12px 10px 0 10px !important; // 小屏幕减少顶部间距

    .nav {
      max-width: 100% !important;
      margin: 8px auto 20px auto !important; // 小屏幕进一步减少顶部间距
      border-radius: 12px !important;

      &-item {
        margin: 0 8px !important;
        padding: 14px 20px !important;
        min-height: 52px !important;

        .icon-tb {
          width: 20px !important;
          height: 18px !important;
          margin-right: 12px !important;
        }

        span {
          font-size: 15px !important;
        }
      }
    }

    .main {
      padding: 16px 20px 0 20px !important;
    }
  }
}

// 针对超小屏幕的优化
@media (max-width: 320px) {
  .help-content {
    padding: 8px 5px 0 5px !important; // 超小屏幕进一步减少顶部间距

    .nav {
      &-item {
        padding: 12px 16px !important;
        margin: 0 4px !important;

        span {
          font-size: 14px !important;
        }
      }
    }
  }
}
</style>
